export default __webpack_public_path__ + "static/media/parking.96313be1.png";